module.exports = __webpack_public_path__ + "assets/panels/powermaster-10-d97bf2012c80a99f769e1a625230c217.svg";